var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 36C71.25 55.468 55.468 71.25 36 71.25C16.532 71.25 0.75 55.468 0.75 36C0.75 16.532 16.532 0.75 36 0.75C55.468 0.75 71.25 16.532 71.25 36Z",
    stroke: "#E8E9E9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 22.25C21.7312 22.25 20.5 23.4812 20.5 25V27V50V53C20.5 54.5188 21.7312 55.75 23.25 55.75H43.25C44.7688 55.75 46 54.5188 46 53V50V27V25C46 23.4812 44.7688 22.25 43.25 22.25H23.25ZM22 53V50.75H44.5V53C44.5 53.6904 43.9404 54.25 43.25 54.25H23.25C22.5596 54.25 22 53.6904 22 53ZM22 49.25H44.5V27.75H22V49.25ZM44.5 26.25V25C44.5 24.3096 43.9404 23.75 43.25 23.75H23.25C22.5596 23.75 22 24.3096 22 25V26.25H44.5ZM33.25 53.5C33.8023 53.5 34.25 53.0523 34.25 52.5C34.25 51.9477 33.8023 51.5 33.25 51.5C32.6977 51.5 32.25 51.9477 32.25 52.5C32.25 53.0523 32.6977 53.5 33.25 53.5Z",
    fill: "#626569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 35.625C32.1454 35.625 31.25 36.3805 31.25 37.3125C31.25 38.2445 32.2603 38.7912 33.25 39C34.2397 39.2088 35.25 39.7555 35.25 40.6875C35.25 41.6195 34.3546 42.375 33.25 42.375M33.25 35.625C34.3546 35.625 34.9801 36.1746 35.25 36.75M33.25 35.625V34.5M33.25 42.375C32.1454 42.375 31.4468 41.7917 31.25 41.25M33.25 42.375V43.5",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0303 30.0303C27.3232 29.7374 27.3232 29.2626 27.0303 28.9697C26.7374 28.6768 26.2626 28.6768 25.9697 28.9697L22.9697 31.9697C22.6768 32.2626 22.6768 32.7374 22.9697 33.0303C23.2626 33.3232 23.7374 33.3232 24.0303 33.0303L27.0303 30.0303ZM30.5303 30.5303C30.8232 30.2374 30.8232 29.7626 30.5303 29.4697C30.2374 29.1768 29.7626 29.1768 29.4697 29.4697L23.4697 35.4697C23.1768 35.7626 23.1768 36.2374 23.4697 36.5303C23.7626 36.8232 24.2374 36.8232 24.5303 36.5303L30.5303 30.5303Z",
    fill: "#FFA89E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 23V22C25.25 20.8954 26.1454 20 27.25 20H47.25C48.3546 20 49.25 20.8954 49.25 22V50C49.25 51.1046 48.3546 52 47.25 52H46.25",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 20V19C29.25 17.8954 30.1454 17 31.25 17H51.25C52.3546 17 53.25 17.8954 53.25 19V47C53.25 48.1046 52.3546 49 51.25 49H50.25",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22V17M17 19.5H22",
    stroke: "#FFA89E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 55V52M52 53.5H55",
    stroke: "#FFA89E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.440ffd59a6daa7dabf224c3333b764a7.svg";
export { ForwardRef as ReactComponent };